<template>
  <v-alert
    v-model="alert"
    text
    outlined
    :type="type || 'success'"
    :icon="icon"
    elevation="2"
    :dismissible="dismissible"
  >
    <span v-html="msg"></span>
  </v-alert>
</template>

<script>
export default {
  name: "LoginAlerts",
  data() {
    return {
      alert: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    msg: {
      type: String,
      default: ""
    }
  },
  watch: {
    show() {
      this.alert = this.show;
    },
    alert() {
      if (!this.alert) {
        this.$emit("close");
      }
    }
  },
  computed: {
    icon() {
      return this.type === "error" ? "mdi-alert-circle-outline" : "mdi-check";
    }
  }
};
</script>
